// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
// @ components
const ImpositionInterestRenewalView = require('components/contactCenter/impositionInterestRenewal/impositionInterestRenewalView.js');
// @ actions
const impositionInterestRenewalActions = require('actions/contactCenter/impositionInterestRenewal');
const depositsActions = require('actions/deposits');
const accountIntervenersActions = require('actions/getAccountInterveners');

class ImpositionInterestRenewalContainer extends React.Component {
    render () {
        return (
            <ImpositionInterestRenewalView
                {...this.props}
            />
        );
    }
}

ImpositionInterestRenewalContainer.propTypes = {
    immAccounts: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immImpositionInterestRenewal: PropTypes.object.isRequired,
    requestDeposits: PropTypes.func.isRequired,
    immDeposits: PropTypes.object.isRequired,
    requestInterveners: PropTypes.func.isRequired,
    immInvestmentFunds: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
};

module.exports.constructor = ImpositionInterestRenewalContainer;
module.exports.ImpositionInterestRenewalContainer = connect(state => ({
    immProfile: state.profile,
    immImpositionInterestRenewal: state.impositionInterestRenewal,
    immInvestmentFunds: state.investmentFunds.get('list'),
    immDeposits: state.deposits,
    immAccounts: state.accounts,
}), {
    requestDeposits: depositsActions.requestDeposits,
    renewImpositionInterest: impositionInterestRenewalActions.renewImpositionInterest,
    setVisibleStep: impositionInterestRenewalActions.setVisibleStep,
    requestInterveners: accountIntervenersActions.requestAccountInterveners,
    validateStep: impositionInterestRenewalActions.validateStep,
    showCancelModal: impositionInterestRenewalActions.showCancelModal,
    reset: impositionInterestRenewalActions.reset
})(ImpositionInterestRenewalContainer);
